import React from 'react';
import { enhanceWrapped, InputBase } from '../../../../components/InputBase';
import '../../../../components/sharedStyle.scss';
import chatbotCRUDActions from '@mm/state/actions/ChatbotCRUDActions';
import ChatbotModel from '@mm/state/model/ChatbotModel';
import SettingSection from '../../../../components/SettingSection/SettingSection';

const INPUT_PLACEHOLDER = 'Enter bot name';
const FIELD_TO_UPDATE = 'name';
export const MAX_BOT_NAME_LENGTH = 25;
export const BOT_NAME_LENGTH_ERROR =
  'Bot name should be at least 1 and less than 25';
export const BOT_ALREADY_EXISTS_ERROR =
  'Bot with this the same name already exists';

const validateEntity =
  ({ chatbotNames }) =>
  botName => {
    if (!botName || botName.length > MAX_BOT_NAME_LENGTH) {
      return { error: BOT_NAME_LENGTH_ERROR };
    }
    if (chatbotNames.includes(botName)) {
      return { error: BOT_ALREADY_EXISTS_ERROR };
    }
    return null;
  };

const enhance = enhanceWrapped(
  FIELD_TO_UPDATE,
  undefined,
  INPUT_PLACEHOLDER,
  chatbotCRUDActions,
  validateEntity,
);

const BotNameInput = enhance(InputBase);

type Props = {
  chatbot: ChatbotModel;
};

const BotName = ({ chatbot }: Props) => {
  return (
    <SettingSection
      title="Bot Name"
      helpLink="https://mobilemonkey.com/help/article/zycny3hlt1-bot-settings"
    >
      <BotNameInput entity={chatbot} />
    </SettingSection>
  );
};

export default BotName;
